<div class="brand">
  <div class="logo" *ngIf="logoUrl">
    <img [src]="logoUrl" alt="Tandas HN Logo" />
  </div>

  <div class="text">
    <div class="tag">Administrador</div>
  </div>
</div>

<mat-divider></mat-divider>

<mat-nav-list class="nav">
  <a
    *ngIf="permissions.hasAnyInModule(PERMISSIONS.MODULES.DASHBOARD)"
    mat-list-item
    routerLink="/app/home"
    routerLinkActive="active"
    (click)="onNavigate()"
  >
    <mat-icon matListItemIcon>home</mat-icon>
    <span matListItemTitle>Home</span>
  </a>

  <mat-accordion class="accordion" multi="true">
    <mat-expansion-panel
      *ngIf="permissions.hasAnyInModule(PERMISSIONS.MODULES.TANDAS)"
      class="panel"
      [expanded]="true"
    >
      <mat-expansion-panel-header>
        <mat-panel-title>
          <mat-icon class="panel-icon">groups</mat-icon>
          Tandas
        </mat-panel-title>
        <mat-panel-description class="panel-desc">
          <mat-icon class="arrow">expand_more</mat-icon>
        </mat-panel-description>
      </mat-expansion-panel-header>

      <!-- Subopción Jerarquías -->
      <a
        mat-list-item
        class="sub-item"
        routerLink="/app/tandas"
        (click)="onNavigate()"
        *ngIf="
          permissions.has(
            PERMISSIONS.MODULES.TANDAS,
            PERMISSIONS.ACTIONS.VER_RED_TANDAS
          )
        "
      >
        <mat-icon matListItemIcon>account_tree</mat-icon>
        <span matListItemTitle>Tandas</span>
      </a>
      <a
        mat-list-item
        class="sub-item"
        routerLink="/app/administration-tandas"
        (click)="onNavigate()"
        *ngIf="
          permissions.has(
            PERMISSIONS.MODULES.TANDAS,
            PERMISSIONS.ACTIONS.ADMINISTRACION_TANDAS
          )
        "
      >
        <mat-icon matListItemIcon>dashboard_2_gear</mat-icon>
        <span matListItemTitle>Administrar</span>
      </a>
    </mat-expansion-panel>

    <mat-expansion-panel
      *ngIf="permissions.hasAnyInModule(PERMISSIONS.MODULES.CUENTAS)"
      class="panel"
    >
      <mat-expansion-panel-header>
        <mat-panel-title>
          <mat-icon class="panel-icon">account_balance_wallet</mat-icon>
          Cuentas
        </mat-panel-title>
        <mat-panel-description class="panel-desc">
          <mat-icon class="arrow">expand_more</mat-icon>
        </mat-panel-description>
      </mat-expansion-panel-header>

      <!-- Subopción Jerarquías -->
      <a
        mat-list-item
        class="sub-item"
        routerLink="/app/payments"
        (click)="onNavigate()"
        *ngIf="
          permissions.has(
            PERMISSIONS.MODULES.CUENTAS,
            PERMISSIONS.ACTIONS.VER_SOLICITUDES_CUENTAS
          )
        "
      >
        <mat-icon matListItemIcon>shopping_cart_checkout</mat-icon>
        <span matListItemTitle>Solicitudes</span>
      </a>

      <a
        mat-list-item
        class="sub-item"
        routerLink="/app/accounts"
        (click)="onNavigate()"
        *ngIf="
          permissions.has(
            PERMISSIONS.MODULES.CUENTAS,
            PERMISSIONS.ACTIONS.VER_CUENTAS
          )
        "
      >
        <mat-icon matListItemIcon>account_circle</mat-icon>
        <span matListItemTitle>Cuentas</span>
      </a>

      <a
        mat-list-item
        class="sub-item"
        routerLink="/app/remove-accounts"
        (click)="onNavigate()"
        *ngIf="
          permissions.has(
            PERMISSIONS.MODULES.CUENTAS,
            PERMISSIONS.ACTIONS.REMOVER_CUENTAS
          )
        "
      >
        <mat-icon matListItemIcon>person_remove</mat-icon>
        <span matListItemTitle
          >Remover <br />
          Cuentas</span
        >
      </a>

      <a
        mat-list-item
        class="sub-item"
        routerLink="/app/accounts-removed"
        (click)="onNavigate()"
        *ngIf="
          permissions.has(
            PERMISSIONS.MODULES.CUENTAS,
            PERMISSIONS.ACTIONS.CUENTAS_REMOVIDAS
          )
        "
      >
        <mat-icon matListItemIcon>no_accounts</mat-icon>
        <span matListItemTitle
          >Cuentas <br />
          Removidas</span
        >
      </a>
    </mat-expansion-panel>

    <mat-expansion-panel
      *ngIf="permissions.hasAnyInModule(PERMISSIONS.MODULES.PAYMENTS)"
      class="panel"
    >
      <mat-expansion-panel-header>
        <mat-panel-title>
          <mat-icon class="panel-icon">shopping_cart_checkout</mat-icon>
          Pagos
        </mat-panel-title>
        <mat-panel-description class="panel-desc">
          <mat-icon class="arrow">expand_more</mat-icon>
        </mat-panel-description>
      </mat-expansion-panel-header>

      <a
        *ngIf="
          permissions.has(
            PERMISSIONS.MODULES.PAYMENTS,
            PERMISSIONS.ACTIONS.VER_PAGOS_NIVEL1
          )
        "
        mat-list-item
        class="sub-item"
        routerLink="/app/payment-verification"
        (click)="onNavigate()"
      >
        <mat-icon matListItemIcon>payments</mat-icon>
        <span matListItemTitle>Pagos N.1</span>
      </a>

      <a
        *ngIf="
          permissions.has(
            PERMISSIONS.MODULES.PAYMENTS,
            PERMISSIONS.ACTIONS.VER_PAGOS_NIVEL2
          )
        "
        mat-list-item
        class="sub-item"
        routerLink="/app/payment-account-transfer"
        (click)="onNavigate()"
      >
        <mat-icon matListItemIcon>payments</mat-icon>
        <span matListItemTitle>Pagos N.2</span>
      </a>
    </mat-expansion-panel>

    <mat-expansion-panel
      *ngIf="permissions.hasAnyInModule(PERMISSIONS.MODULES.CLIENTS)"
      class="panel"
    >
      <mat-expansion-panel-header>
        <mat-panel-title>
          <mat-icon class="panel-icon">person</mat-icon>
          Clientes
        </mat-panel-title>
        <mat-panel-description class="panel-desc">
          <mat-icon class="arrow">expand_more</mat-icon>
        </mat-panel-description>
      </mat-expansion-panel-header>

      <a
        mat-list-item
        class="sub-item"
        routerLink="/app/clients"
        (click)="onNavigate()"
        *ngIf="
          permissions.has(PERMISSIONS.MODULES.CLIENTS, PERMISSIONS.ACTIONS.VIEW)
        "
      >
        <mat-icon matListItemIcon>person</mat-icon>
        <span matListItemTitle>Clientes</span>
      </a>
    </mat-expansion-panel>

    <mat-expansion-panel
      *ngIf="permissions.hasAnyInModule(PERMISSIONS.MODULES.USERS)"
      class="panel"
    >
      <mat-expansion-panel-header>
        <mat-panel-title>
          <mat-icon class="panel-icon">manage_accounts</mat-icon>
          Usuarios
        </mat-panel-title>
        <mat-panel-description class="panel-desc">
          <mat-icon class="arrow">expand_more</mat-icon>
        </mat-panel-description>
      </mat-expansion-panel-header>

      <a
        mat-list-item
        class="sub-item"
        routerLink="/app/users"
        (click)="onNavigate()"
        *ngIf="
          permissions.has(PERMISSIONS.MODULES.USERS, PERMISSIONS.ACTIONS.VIEW)
        "
      >
        <mat-icon matListItemIcon>manage_accounts</mat-icon>
        <span matListItemTitle>Usuarios</span>
      </a>
    </mat-expansion-panel>
    <mat-expansion-panel
      class="panel"
      *ngIf="permissions.hasAnyInModule(PERMISSIONS.MODULES.BANK_ACCOUNTS)"
    >
      <mat-expansion-panel-header
        *ngIf="
          permissions.has(
            PERMISSIONS.MODULES.BANK_ACCOUNTS,
            PERMISSIONS.ACTIONS.VIEW
          )
        "
      >
        <mat-panel-title>
          <mat-icon class="panel-icon">account_balance</mat-icon>

          Cuentas bancarias
        </mat-panel-title>
        <mat-panel-description class="panel-desc">
          <mat-icon class="arrow">expand_more</mat-icon>
        </mat-panel-description>
      </mat-expansion-panel-header>
      <a
        mat-list-item
        class="sub-item"
        routerLink="/app/bank-accounts"
        (click)="onNavigate()"
      >
        <mat-icon matListItemIcon>account_balance</mat-icon>
        <span matListItemTitle
          >Cuentas <br />
          bancarias</span
        >
      </a>
    </mat-expansion-panel>

    <mat-expansion-panel
      class="panel"
      *ngIf="permissions.hasAnyInModule(PERMISSIONS.MODULES.CONFIGURATION)"
    >
      <mat-expansion-panel-header
        *ngIf="
          permissions.has(
            PERMISSIONS.MODULES.CONFIGURATION,
            PERMISSIONS.ACTIONS.VER_CONFIGURACION
          )
        "
      >
        <mat-panel-title>
          <mat-icon class="panel-icon">settings</mat-icon>
          Configuración del sistema
        </mat-panel-title>
        <mat-panel-description class="panel-desc">
          <mat-icon class="arrow">expand_more</mat-icon>
        </mat-panel-description>
      </mat-expansion-panel-header>

      <a
        mat-list-item
        class="sub-item"
        routerLink="/app/configuration"
        (click)="onNavigate()"
      >
        <mat-icon matListItemIcon>build</mat-icon>
        <span matListItemTitle
          >Administrar <br />
          configuración</span
        >
      </a>
    </mat-expansion-panel>
  </mat-accordion>
</mat-nav-list>
